var map = {
	"./Changing_individual_coefficients.svg": 9264,
	"./Individual_coefficients.svg": 3672,
	"./RU_and_unprofitability.svg": 6389,
	"./Selection_of_coefficients.svg": 485,
	"./back.svg": 4075,
	"./cash.svg": 8287,
	"./cl1.svg": 372,
	"./completed_triangle.svg": 5292,
	"./copy.svg": 2541,
	"./cumulative_triangle.svg": 5354,
	"./delete.svg": 5863,
	"./download.svg": 2446,
	"./evaluations.svg": 7059,
	"./exit.svg": 8966,
	"./filter_to_clear.svg": 9422,
	"./home.svg": 6775,
	"./incremental_more_detailed.svg": 433,
	"./incremental_triangle.svg": 7637,
	"./indicator_active.svg": 8702,
	"./indicator_blue.svg": 9156,
	"./indicator_no_active.svg": 4654,
	"./indicator_side_menu_active.svg": 6026,
	"./indicator_side_menu_no_active.svg": 8810,
	"./indicator_vinous.svg": 9746,
	"./indicator_white.svg": 7023,
	"./info.svg": 2310,
	"./kept_logo_1.svg": 3200,
	"./kept_logo_2.svg": 3939,
	"./loading.svg": 7106,
	"./lock.svg": 1447,
	"./manual.svg": 452,
	"./product.svg": 9083,
	"./profile_.svg": 1616,
	"./result.svg": 361,
	"./risky.svg": 2432,
	"./settings.svg": 5189,
	"./vault.svg": 6634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9832;